class Role {
  constructor(id
  /*: ?string*/
  , sid
  /*: ?string*/
  , name
  /*: string*/
  , description
  /*: string*/
  , type
  /*: string*/
  ) {
    this.id = id;
    this.sid = sid;
    this.name = name;
    this.description = description;
    this.type = type;
  }

}

module.exports = Role;